/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgPlot12(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={12}
      height={12}
      fill='none'
      viewBox='0 0 12 12'
      {...props}
    >
      <path
        fill='currentColor'
        fillRule='evenodd'
        d='M10 2.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zm-5 4a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0zM9.5 12a2.5 2.5 0 100-5 2.5 2.5 0 000 5z'
      />
    </svg>
  );
}

export default SvgPlot12;
